export default __webpack_public_path__ + "static/koving1-1c380dd9bafb11c5625e160cd97a2bbe.png";